import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Name extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Name {
    if (!(value.length > 0)) {
      throw new Error('名前が入力されていません');
    }
    return new Name(value);
  }

  /** ラベル */
  static get label(): string {
    return '名前 (保護者)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '太郎';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** キー */
  static get key() {
    return 'name';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
